'use client'

import dynamic from 'next/dynamic'

import { RenderOnScroll } from '@/components/RenderOnScroll'

import type { TShowcaseSectionProps } from './ShowcaseSection'

const DynamicShowcaseSection = dynamic(() =>
	import('./ShowcaseSection').then((mod) => mod.ShowcaseSection),
)

export const LazyShowcaseSection = (props: TShowcaseSectionProps) => (
	<div id="showcase" className="min-h-[950px] desktop:min-h-[750px]">
		<RenderOnScroll element={<DynamicShowcaseSection {...props} />} />
	</div>
)
